import React from "react";
import { FiArrowLeft } from "react-icons/fi";

const BackIcon = FiArrowLeft;

export default function SettingsHeader({ t, title, subtitle, onBack, showBack = true }) {
  return (
    <header className="pp-settings-header pp-settings-subheader">
      {showBack && (
        <button type="button" className="pp-settings-back pp-settings-back-button" onClick={onBack}>
          <BackIcon aria-hidden="true" />
          {t("common.back", { defaultValue: "Back" })}
        </button>
      )}
      <div className="pp-settings-title-block">
        <h2>{title}</h2>
        {subtitle && <p className="pp-settings-subtitle">{subtitle}</p>}
      </div>
    </header>
  );
}
